export class Stock {
  stock_id: number;
  name: string;
  description: string;

  /**
   * Constructor
   *
   * @param stock
   */
  constructor(stock) {
    this.stock_id    = stock.stock_id    || 0;
    this.name        = stock.name        || '';
    this.description = stock.description || '';
  }
}
